import React, { useContext, useEffect, useState } from "react";
import Header from "../header";
import SelectRecords from "../selectRecords";
import PsContext from "../../context";
import { _ClassWisePendingFees } from "../../models/pay";
import { List } from "antd-mobile";
import { Empty } from "antd";

const ClassFeePendings = (props) => {
  const context = useContext(PsContext);
  const [selectedCourse, setSelectedCourse] = useState([]);
  const [dataList, setDataList] = useState([]);
  const [dataView, setDataView] = useState([]);

  useEffect(() => {
    if (selectedCourse.batch) loadData();
  }, [selectedCourse]);
  const loadData = () => {
    context.setLoader(true);
    selectedCourse.academic_year = selectedCourse.batch;
    _ClassWisePendingFees(selectedCourse).then((res) => {
      if (res.status == "1") {
        let m = res.data.filter(
          (item) => item.total_unpaid && parseFloat(item.total_unpaid) > 0
        );
        setDataList(res.data);
        setDataView(m);
      }
      context.setLoader(false);
    });
  };

  return (
    <>
      <Header backAction={true} title={"Fee Pendings"} rightActions={[]} />
      <div className="">
        <div className="container-sm py-md-3">
          {!selectedCourse.batch && (
            <div data-aos="zoom-in">
              <SelectRecords
                onSuccess={(d) => setSelectedCourse(d)}
                currentSem={true}
                allowdCoursesOnly={true}
              />
            </div>
          )}
          {selectedCourse.batch && (
            <>
              {dataView.length > 0 && (
                <div>
                  <List>
                    {dataView.map((item, i) => {
                      return (
                        <List.Item
                          key={i}
                          extra={item.total_unpaid}
                          description={item.student_name}
                        >
                          <span className="fw-bolder">
                            {item.registerno || item.admissionno}
                          </span>
                        </List.Item>
                      );
                    })}
                  </List>
                </div>
              )}
              {dataView.length < 1 && (
                <div className="mt-5">
                  <Empty description="No fees are outstanding." />
                </div>
              )}
            </>
          )}
        </div>
        <div className="py-4"></div>
      </div>
    </>
  );
};
export default ClassFeePendings;
